module.exports = __webpack_public_path__ + "img/speech_5.3a3da829.jpeg";